import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React, { useState, useEffect, useRef, useImperativeHandle, createRef, forwardRef } from 'react';
import { useMemoizedFn } from 'ahooks';
import { renderToBody } from './render-to-body';
export function renderImperatively(element) {
  var Wrapper = /*#__PURE__*/forwardRef(function (_, ref) {
    var _useState = useState(false),
        visible = _useState[0],
        setVisible = _useState[1];

    var closeRef = useRef(false);

    var _useState2 = useState(element),
        elementToRender = _useState2[0],
        setElementToRender = _useState2[1];

    var keyRef = useRef(0);
    var onClose = useMemoizedFn(function () {
      var _a, _b;

      closeRef.current = true;
      setVisible(false);
      (_b = (_a = elementToRender.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    });
    var afterClose = useMemoizedFn(function () {
      var _a, _b;

      unmount();
      (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
    });
    useEffect(function () {
      if (!closeRef.current) {
        setVisible(true);
      } else {
        afterClose();
      } // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);
    useImperativeHandle(ref, function () {
      return {
        close: onClose,
        replace: function replace(newElement) {
          var _a, _b;

          keyRef.current += 1;
          (_b = (_a = elementToRender.props).afterClose) === null || _b === void 0 ? void 0 : _b.call(_a);
          setElementToRender(newElement);
        }
      };
    });
    return /*#__PURE__*/React.cloneElement(elementToRender, Object.assign(Object.assign({}, elementToRender.props), {
      key: keyRef.current,
      // force render
      visible: visible,
      onClose: onClose,
      afterClose: afterClose
    }));
  });
  var wrapperRef = /*#__PURE__*/createRef();
  var unmount = renderToBody( /*#__PURE__*/React.createElement(Wrapper, {
    ref: wrapperRef
  }));
  return {
    close: function close() {
      var _a;

      (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.close();
    },
    replace: function replace(newElement) {
      var _a;

      (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.replace(newElement);
    }
  };
}